export const /** @type {?} */ OFFICE_PHONE = {
  area: '021',
  phone: '40005859',
};
